import { createSelector } from '@reduxjs/toolkit';
import { selectOfferTypeLabel } from './selectOfferTypeLabel';
import { selectOfferTypeOptions } from './selectOfferTypeOptions';
import { selectOfferTypeValue } from './selectOfferTypeValue';

export const selectOfferTypeFilter = createSelector(
  [selectOfferTypeLabel, selectOfferTypeOptions, selectOfferTypeValue],
  (label, options, value) => ({
    label,
    options,
    value,
  }),
);
